// extracted by mini-css-extract-plugin
export var downArrow = "_f5-0";
export var infoTooltipIcon = "_f5-3";
export var label = "_f5-1";
export var optionCard = "_f5-4";
export var upArrow = "_f5-2";